import { defineMessages } from 'react-intl'

export default defineMessages({
  attractions: {
    id: 'event.attractions',
    defaultMessage: 'Attractions',
  },
  readMore: {
    id: 'event.attractions.headlinerCard.readMore',
    defaultMessage: 'Read more',
  },
  sectionNameHeadliners: {
    id: 'event.attractions.titles.headliners',
    defaultMessage: 'Headliners',
  },
  sectionNameLineup: {
    id: 'event.attractions.titles.lineup',
    defaultMessage: 'Lineup',
  },
  sectionNameSpecialGuests: {
    id: 'event.attractions.titles.specialGuests',
    defaultMessage: 'Special Guests',
  },
  sectionNameArtists: {
    id: 'event.attractions.titles.artists',
    defaultMessage: 'Artists',
  },
  sectionNameAttractions: {
    id: 'event.attractions.titles.main',
    defaultMessage: 'Attractions',
  },
  sectionOpeningAct: {
    id: 'event.attractions.titles.openingAct',
    defaultMessage: 'Opening Act',
  },
})
